import { Alert, Link } from '@apollo/orbit';
// TODO: Update to use Orbit's components instead
// eslint-disable-next-line no-restricted-imports
import { List, ListItem } from '@chakra-ui/react';
import React from 'react';

import { variantRouteConfig } from 'src/app/graph/routes';
import { format } from 'src/lib/format';
import { GraphQLTypes } from 'src/lib/graphqlTypes';

import { getRecentlyUpdatedVariants } from './DeleteGraphHelpers';

export const DeleteGraphModalContent = ({
  service,
  errorMessage,
}: {
  service: GraphQLTypes.DeleteGraphCardServiceFragment;
  errorMessage?: string;
}) => {
  const recentlyUpdatedVariants = getRecentlyUpdatedVariants(service);
  const totalVariants = service.variants.length;
  const firstTenVariants = service.variants.slice(0, 10);

  return (
    <>
      {errorMessage && <Alert status="error">{errorMessage}</Alert>}
      {recentlyUpdatedVariants.length > 0 && (
        <Alert status="warning">
          <b>You have {recentlyUpdatedVariants.length} active variants</b> on
          this graph which have either published a schema or sent metrics in the
          last 30 days.
        </Alert>
      )}
      <p>
        Deleting your graph will also delete its {totalVariants}{' '}
        {format.pluralize(service.variants.length, 'variant')} :
        <List className="mt-2 list-inside list-disc text-link">
          {firstTenVariants.map((variant) => {
            return (
              <ListItem key={variant.id}>
                <Link
                  to={variantRouteConfig.location({
                    graphId: service.id,
                    graphVariant: variant.name,
                  })}
                >
                  {variant.name}
                </Link>
              </ListItem>
            );
          })}{' '}
        </List>
        {/* Only show if there are more than ten total variants */}
        {totalVariants > 10 &&
          totalVariants &&
          ` ... and ${totalVariants - firstTenVariants.length} more.`}
      </p>
      <p>
        This is a permanent action, and you will not be able to reclaim your
        graph ID after deletion.
      </p>
      <p className="font-semibold">
        This action cannot be undone. Type “{service.title}” to confirm.
      </p>
    </>
  );
};
